import { type ChainArch } from "@umi/shared/chains";
import { createPk } from "@/utils/wallets";


/**
 * @explain
 * List of workers used to perform long running tasks
 * or tasks that could be detrimental to the UI performance.
 */

/**
 * We create pks in a worker because the generation of
 * pks can be slow and we don't want to block the UI.
 * @param chainArch
 * @param count
 * @returns
 */
export const createPksWorker = (
  chainArch: ChainArch,
  count: number,
) => {
  return new Array(count).fill(null).map(() => createPk(chainArch));
};
